<template>
    <div class="interface-help">
        <h2>Почтовый клиент</h2>
        <p>
            Данный интерфейс имитирует работу с почтовым клиентом. Он состоит из двух колонок.
        </p>
        <p>
            В левой колонке расположен список каталогов.<br>
            <img class="interface-help__image interface-help__image--1" src="/images/help/mail-folders.jpg" alt="">
        </p>
        <p>
            В интерфейсе отображается количество писем в папке.<br>
            <img class="interface-help__image interface-help__image--2" src="/images/help/mail-count.jpg" alt="">
        </p>
        <p>
            В правой колонке расположен список писем в выбранной директории. Чтобы просмотреть содержимое каталога, его необходимо выбрать путем нажатия на курсор. По умолчанию же отображается содержимое папки "Входящие".<br>
            <img class="interface-help__image interface-help__image--3" src="/images/help/mail-list.jpg" alt="">
        </p>
        <p>
            При клике на письмо внизу страницы открывается его содержимое.<br>
            <img class="interface-help__image interface-help__image--4" src="/images/help/mail-content.jpg" alt="">
        </p>
        <p>
            Для сортировки писем их можно перемещать в другие каталоги. Для этого нужно кликнуть по письму в списке и потащить его в нужную директорию. Если каталог поддерживает добавление в него писем, вокруг него появится синяя рамка.<br>
            <img class="interface-help__image interface-help__image--5" src="/images/help/mail-drag.jpg" alt="">
        </p>
        <p>
            Если необходимо создать новый каталог, то это можно сделать, нажав на троеточие справа от существующих каталогов.<br>
            <img class="interface-help__image interface-help__image--6" src="/images/help/mail-points.jpg" alt="">
        </p>
        <p>
            При клике откроется следующее контекстное меню. С его помощью можно либо удалить текущий, либо добавить вложенный каталог.<br>
            <img class="interface-help__image interface-help__image--7" src="/images/help/mail-menu.jpg" alt="">
        </p>
        <p>
            Общий вид почтового клиента<br>
            <img class="interface-help__image" src="/images/help/mail.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                width 245px
            }

            &--2 {
                width 150px
            }

            &--3 {
                width 650px
            }

            &--4 {
                width 730px
            }

            &--5 {
                width 515px
            }

            &--6 {
                width 46px
            }

            &--7 {
                width 181px
            }
        }
    }
</style>